export default "__VITE_ASSET__Jf6gUtpc__"